import { render, staticRenderFns } from "./MarketplaceReviewsTable.vue?vue&type=template&id=467f22c1&scoped=true"
import script from "./MarketplaceReviewsTable.vue?vue&type=script&lang=js"
export * from "./MarketplaceReviewsTable.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceReviewsTable.vue?vue&type=style&index=0&id=467f22c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f22c1",
  null
  
)

export default component.exports